import DpiChargesActions from "@frameworks/web/redux/actions/Reports/DpInterest/DpiCharges";
import DpiDetailsActions from "@frameworks/web/redux/actions/Reports/DpInterest/DpiDetails";
export default () => {
    return {
        dpInterestCharges: new DpiChargesActions(),
        dpInterestDetails: new DpiDetailsActions(),
    };
};
